import { getColorFromBGColor } from "#scripts/tools/textcolor.js";
export default (obj) => {
	return `
        <section  id="module__cards_${obj.id}" class="module__cards ${obj.cardDesign} p-md-0 justify-content-md-center">
            <div class="container p-0">
                ${
									obj.title !== ""
										? `
                    <div class="row">
                        <div class="col"><h2 class="card__module__title">${obj.title}</h2></div>
                    </div>
                    `
										: ""
								}
                <div class="cards" id="cards_${obj.id}">

                </div>
                ${
									obj.moretitle.trim() !== ""
										? `
                <div class="row">
                    <div class="col text-right">
                        <div class="card__more__container">
                            <a class="card__more__link" href="${obj.morelink}">${obj.moretitle} <span class="material-icons-outlined notranslate news__more__icon">&#xE5C8;</span></a>
                        </div>
                    </div>
                </div>`
										: ""
								}
            </div>
        </section>`;
};

export const carditem = (obj) => {
    const txtColor = getColorFromBGColor(obj.color);
    const colorStyle = obj.color !== "" && obj.color.toUpperCase() !== "#FFFFFF" && obj.color.toUpperCase() !== "#FFF" && obj.color.toLowerCase() !== "transparent"
        ? `style="background-color:${obj.color};color:${txtColor}"`
        : `style="color:var(--black__text)"`
	return `
        <a class="card__item" href="${obj.link}" ${colorStyle}>
            <span class="card__tag">${obj.tag}</span>
            ${obj.image}
            <div class="card__content" ${colorStyle}>
                <div class="card__title__container">
                    <span class="material-icons-outlined notranslate menu-icon"></span><span class="card__title">${obj.title}</span>
                </div>
                <p class="card__text">${obj.intro}</p>
            </div>
        </a>
    `;
};
